/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import MedicalAssociation from './medical-association';
import MedicalAssociationDetail from './medical-association-detail';
import MedicalAssociationUpdate from './medical-association-update';
import MedicalAssociationDeleteDialog from './medical-association-delete-dialog';

const MedicalAssociationRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<MedicalAssociation />} />
    <Route path="new" element={<MedicalAssociationUpdate />} />
    <Route path=":id">
      <Route index element={<MedicalAssociationDetail />} />
      <Route path="edit" element={<MedicalAssociationUpdate />} />
      <Route path="delete" element={<MedicalAssociationDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default MedicalAssociationRoutes;
